import React, { useContext, useEffect } from "react";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Alert, Snackbar, Slide } from "@mui/material";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./pages/welcome page components/style.css";
import "./pages/css components/style.css";

import createTheme from "./theme";
import Router from "./router/Router";
import AuthVerification from "./components/AuthVerification";
import { closeAlert } from "./redux/slices/alertSlice";
import { ThemeContext } from "./components/ThemeProvider";

function App() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alertDetails);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    if (alert.multiple && alert.multiple.length > 0) {
      alert.multiple.forEach((msg) =>
        enqueueSnackbar(msg, {
          variant: alert.type,
          autoHideDuration: 4000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    }
  }, [alert.multiple, alert.type, enqueueSnackbar]);

  const handleAlertClose = (_, reason) => {
    if (reason === "clickaway") return;
    dispatch(closeAlert());
  };

  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | CashKaro"
        defaultTitle="ADN-CashKaro Dashboard"
      />
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={createTheme(theme)}>
          <ThemeProvider theme={createTheme(theme)}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              {alert.multiple ? (
                alert.multiple.forEach((msg, i) => {
                  setTimeout(() => {
                    enqueueSnackbar(msg, {
                      key: `${msg}-${Date.now()}-${Math.random()}`,
                      variant: alert.type,
                      autoHideDuration: 6000,
                      anchorOrigin: { vertical: "top", horizontal: "right" },
                    });
                  }, i * 500);
                })
              ) : (
                <Snackbar
                  open={alert.state}
                  autoHideDuration={4000}
                  onClose={handleAlertClose}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  slots={{ transition: SlideTransition }}
                  sx={{
                    top: 8,
                    right: 10,
                    pointerEvents: "none",
                    zIndex: 1400,
                  }}
                >
                  <Alert
                    variant="filled"
                    severity={alert.type}
                    onClose={handleAlertClose}
                    style={{ minWidth: "350px" }}
                    sx={{ pointerEvents: "auto" }}
                  >
                    {alert.message}
                  </Alert>
                </Snackbar>
              )}
              <Router />
              <AuthVerification />
            </LocalizationProvider>
          </ThemeProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  );

  function SlideTransition(props) {
    return <Slide {...props} direction="right" />;
  }
}

export default App;
